import {toCamelCase} from 'case-converter'
import {
  assignPrices,
  checkPricesWarnings, fetchErrorsHandler, fetchStart, fetchSuccessful,
  fetchSynchronizer,
  filterByValues, getFetchDate,
  switchMbToGb
} from '~/helpers/prices/_utils/prices'
import {clonePrices} from '~/helpers/prices/vpc/_clone-prices'
import {Group, Resource} from '~/helpers/prices/vpc/enum'
import {KOPECKS_IN_RUBLE} from '~/helpers/constants'

export const state = () => ({
  pricesVpc: [],
  vpcFetchDate: '',
  fetchingNow: false,
  fetchingResult: ''
})

export const mutations = {
  setVpcPrices(state, value) {
    state.pricesVpc = value
  },
  setVpcFetchDate(state, value) {
    state.vpcFetchDate = value
  },
  setFetchingState(state, value) {
    state.fetchingNow = value
  },
  setFetchingResult(state, value) {
    state.fetchingResult = value
  }
}

export const actions = {
  async fetchVpcPrices({commit, state}, options) {
    if (state.fetchingNow) {
      return fetchSynchronizer(commit, state)
    } else {
      fetchStart(commit)

      return this.$http.$get('https://api.selectel.ru/prices/vpc?currency=rub', options)
        .then(res => toCamelCase(res))
        .then(prices => assignPrices(prices, clonePrices, ['group', 'resource']))
        .then(prices => checkPricesWarnings(prices))
        .then(prices => switchMbToGb(prices))
        .then(prices => {
          commit('setVpcPrices', prices)

          commit('setVpcFetchDate', getFetchDate())

          fetchSuccessful(commit)

          return prices
        })
        .catch(err => fetchErrorsHandler(commit, err))
    }
  }
}

export const getters = {
  getVpcFetchDate(state) {
    return state.vpcFetchDate
  },
  getVpcPrices(state) {
    return state.pricesVpc
  },
  getFilteredByValueVpcPrices(state) {
    return state.pricesVpc.filter(item => item.value)
  },
  getVpcLoadBalancerPrice(state) {
    return filterByValues(
      state.pricesVpc,
      [
        {
          key: 'resource',
          values: Resource.LOAD_BALANCERS
        },
        {
          key: 'group',
          values: Group.RU_1A
        }
      ]
    )[0]?.value / KOPECKS_IN_RUBLE
  },
  getVpcCloudServersConfiguratorPrices(state) {
    return filterByValues(
      state.pricesVpc,
      [
        {
          key: 'resource',
          values: [
            Resource.COMPUTE_CORES,
            Resource.COMPUTE_RAM,
            Resource.VOLUME_GIGABYTES_LOCAL
          ]
        },
        {
          key: 'group',
          values: [
            Group.RU_1A
          ]
        }
      ]
    )
  },
  getVpcCloudServersVolumesConfigurationsPrices(state) {
    return filterByValues(
      state.pricesVpc,
      [
        {
          key: 'resource',
          values: [
            Resource.VOLUME_GIGABYTES_BASIC,
            Resource.VOLUME_GIGABYTES_UNIVERSAL,
            Resource.VOLUME_GIGABYTES_FAST
          ]
        },
        {
          key: 'group',
          values: [
            Group.RU_1A
          ]
        }
      ]
    )
  },
  getVpcCloudServersConfigurationsPrices(state) {
    return filterByValues(
      state.pricesVpc,
      [
        {
          key: 'resource',
          values: [
            Resource.COMPUTE_CORES,
            Resource.COMPUTE_RAM,
            Resource.VOLUME_GIGABYTES_LOCAL
          ]
        },
        {
          key: 'group',
          values: [
            Group.RU_1A
          ]
        }
      ]
    )
  }
}